import React from "react";
import { Logo } from "./Logo";
import ThemeToggle from "./ThemeToggle";
import { Radio, Star, Clock, Globe } from "lucide-react";

const FEATURES = [
  { icon: Globe, label: "50,000+ live stations worldwide" },
  { icon: Radio, label: "Filter by genre, country & language" },
  { icon: Star, label: "Save your favourite stations" },
  { icon: Clock, label: "Recently played, one tap away" },
];

export default function AuthLayout({ children, subtitle }) {
  return (
    <div className="min-h-screen w-full flex bg-rv-darkest">
      {/* Left brand panel */}
      <div className="hidden lg:flex w-[46%] relative overflow-hidden border-r border-rv-border">
        <div
          className="absolute inset-0 opacity-[0.22]"
          style={{
            background:
              "radial-gradient(circle at 22% 18%, #8B5CF6 0%, transparent 45%), radial-gradient(circle at 82% 78%, #22D3EE 0%, transparent 45%)",
          }}
        />
        <div className="relative z-10 flex flex-col justify-between p-14 w-full">
          <Logo size={26} />
          <div>
            <h1 className="text-5xl font-extrabold leading-tight tracking-tight">
              The world's radio.
              <br />
              <span className="rv-gradient-text">Live, 24/7.</span>
            </h1>
            <p className="mt-5 text-rv-sub max-w-md text-[15px] leading-relaxed">
              RadioVerse streams internet radio from every corner of the globe.
              Now on the web, invitation only.
            </p>
            <div className="mt-10 space-y-3.5">
              {FEATURES.map((f, i) => (
                <div
                  key={f.label}
                  className="flex items-center gap-3.5 animate-fadeIn"
                  style={{ animationDelay: `${i * 80}ms` }}
                >
                  <div className="w-9 h-9 rounded-lg bg-rv-card border border-rv-border flex items-center justify-center text-rv-cyan">
                    <f.icon size={17} />
                  </div>
                  <span className="text-rv-sub text-sm">{f.label}</span>
                </div>
              ))}
            </div>
          </div>
          <p className="text-rv-muted text-xs">© 2026 MediaVerse Labs · RadioVerse Web v1.0</p>
        </div>
      </div>

      {/* Right form panel */}
      <div className="flex-1 flex items-center justify-center p-6 sm:p-10 relative">
        <div className="absolute top-5 right-5">
          <ThemeToggle />
        </div>
        <div className="w-full max-w-[420px] animate-fadeIn">
          <div className="lg:hidden mb-8 flex justify-center">
            <Logo size={24} />
          </div>
          {subtitle}
          {children}
        </div>
      </div>
    </div>
  );
}
